import { Loader } from "@tql/ui-components-react/kendo/indicators";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import type { TraxUser } from "~/shared/schemas/trax-user-schema.ts";

import styles from "./index.module.css";

type DeleteUserModalProps = {
	readonly user: TraxUser;
	readonly isDeleting: boolean;
	readonly onConfirm: () => void;
	readonly onCancel: () => void;
};

const getUserDisplayName = (user: TraxUser) => {
	const fullName = [user.firstName, user.lastName].filter(Boolean).join(" ");
	return fullName || user.email;
};

export const DeleteUserModal = ({
	user,
	isDeleting,
	onConfirm,
	onCancel,
}: DeleteUserModalProps) => {
	return (
		<TraxModal
			cancelText={"No"}
			confirmText={"Yes"}
			onCancel={onCancel}
			onClose={onCancel}
			onConfirm={onConfirm}
			showButtonsDisabled={isDeleting}
			title={"Delete User Confirmation"}
			type={"confirmation"}
		>
			{isDeleting ? (
				<div className={styles.userLoader}>
					<Loader
						size={"medium"}
						themeColor={"primary"}
						type={"infinite-spinner"}
					/>
					Deleting User
				</div>
			) : (
				<>
					Are you sure you want to delete{" "}
					<strong>{getUserDisplayName(user)}</strong>?
				</>
			)}
		</TraxModal>
	);
};
